<template>
  <div class="box-404">
    <Header
      :showLogin="showLogin"
      class="header"
      @closeSubHeader="closeSubHeader"
    />
    <SubHeader
      :class="['sub-header', { 'scroll-top': showSubTitle }]"
      :closeMenu="closeMenu"
    />
    <div class="container-404">
      <div class="text-info">
        <p class="msg">
          {{ $t("page404.Ouch") }}
        </p>
        <p>
          {{ $t("page404.couldNotFind") }}
        </p>
        <div class="button" @click="goBack">
          <span class="button-text">{{ $t("page404.backHome") }}</span>
        </div>
      </div>
      <img :src="imgUrl" alt="" class="picture" />
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import SubHeader from "../components/SubHeader.vue";

export default {
  name: "NotFound",
  components: {
    Header,
    SubHeader,
  },
  metaInfo() {
    return {
      title: this.$t("meta.store.title"),
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.$t("meta.store.description"),
        },
        {
          vmid: "keywords",
          name: "keywords",
          content: this.$t("meta.store.keywords"),
        },
        {
          name: "viewport",
          content:
            "width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no",
        },
      ],
    };
  },
  data() {
    return {
      showLogin: 0,
      showDialog: 0,
      showSubTitle: false,
      closeMenu: false,
      imgUrl: `${process.env.VUE_APP_STORE_OSS_URL}/home/404.webp`,
    };
  },
  methods: {
    closeSubHeader() {
      this.closeMenu = true;
    },
    goBack() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="less" scoped>
.box-404 {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.container-404 {
  background: @bg-color;
  padding: 30px 106px;
  flex: 1;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media screen and (max-width: 960px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
  }
  .picture {
    max-width: 940px;
    max-height: 410px;
    @media screen and (max-width: 960px) {
      max-width: 330px;
      max-height: 144px;
      margin-top: 54px;
    }
  }
  .text-info {
    position: absolute;
    left: 106px;
    background: transparent;
    font-style: normal;
    font-size: 56px;
    line-height: 72px;
    color: #000000;
    max-width: 448px;
    box-sizing: border-box;
    @media screen and (max-width: 960px) {
      position: relative;
      width: 100%;
      padding-right: 42px;
      font-size: 36px;
      line-height: 46px;
      left: 15px;
    }
    .button {
      margin-top: 40px;
      background: @primary-color;
      border-radius: 8px;
      font-family: @font-family-bold;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      text-transform: uppercase;
      color: #ffffff;
      width: 186px;
      padding: 16px 0;
      box-sizing: border-box;
      cursor: pointer;
      @media screen and (max-width: 960px) {
        width: 168px;
        padding: 14px 0;
        margin-top: 30px;
      }
    }
  }
}
</style>
